var _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 10,
    fill: "#D0D0D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.391 4.67868L15.8209 6.12047C16.0592 6.36076 16.0592 6.74893 15.8209 6.98923L14.7027 8.11678L12.4112 5.80623L13.5294 4.67868C13.6455 4.56161 13.7983 4.5 13.9572 4.5C14.1161 4.5 14.2688 4.55545 14.391 4.67868ZM5 13.2801V15.5907H7.29145L14.0497 8.77609L11.7583 6.46554L5 13.2801ZM6.78499 14.3583H6.22282V13.7914L11.759 8.20913L12.3211 8.77599L6.78499 14.3583Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.ed444c65d43b882586d716bf5e2fe918.svg";
export { ForwardRef as ReactComponent };